module.exports = __webpack_public_path__ + "static/Bressay-Bold-fb139d56755544035475f28463979ca5.ttf";